import type {
  DefaultMantineColor,
  MantineColorsTuple,
} from "@mantine/core";

export type ExtendedCustomColors =
  | "info"
  | "error"
  | "skyBlue"
  | "warning"
  | "success"
  | "neonGreen"
  | "purpleBlue"
  | "yellowGray"
  | DefaultMantineColor;

declare module "@mantine/core" {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendedCustomColors, MantineColorsTuple>;
  }

  export interface CardProps {
    variant?: "shadowless";
  }
}

/**
 * Colors from Figma
 * https://www.figma.com/design/SGgCOChfc92PZwp5EqMEN0/MAPKA-UI-Kit?node-id=5-1241&p=f&m=dev
 */
export const colors = {
  orange: [
    "#FEF9EC",
    "#FDF4DA",
    "#FDEFC7",
    "#FCE9B5",
    "#FBE3A2",
    "#FADE90",
    "#F9D97E",
    "#F9D36B",
    "#F8CD59",
    "#F7C846",
  ],
  info: [
    "#e5f5fc",
    "#ccecf9",
    "#b2e2f7",
    "#99d9f4",
    "#80cff1",
    "#66c5ee",
    "#4dbceb",
    "#33b2e9",
    "#1aa9e6",
    "#009fe3",
  ],
  error: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a",
  ],
  warning: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f",
  ],
  success: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e",
  ],
  purpleBlue: [
    "#ebe5ff",
    "#d6ccff",
    "#c2b2ff",
    "#ad99ff",
    "#9980ff",
    "#8566ff",
    "#704dff",
    "#5c33ff",
    "#471aff",
    "#3300ff",
  ],
  yellowGray: [
    "#F8F8F5",
    "#F1F2F0",
    "#E9EBEB",
    "#DFE1E2",
    "#CFD4D6",
    "#AFB6BA",
    "#899094",
    "#4E5457",
    "#3A3E41",
    "#272A2A",
  ],
  neonGreen: [
    "#EAFFEA",
    "#D5FFD5",
    "#C1FFC1",
    "#ACFFAC",
    "#97FF97",
    "#82FF82",
    "#6DFF6D",
    "#59FF59",
    "#44FF44",
    "#2FFF2F",
  ],
  skyBlue: [
    "#F2FEFF",
    "#E5FEFF",
    "#D8FDFF",
    "#CBFDFF",
    "#BEFCFF",
    "#B1FBFF",
    "#A4FBFF",
    "#97FAFF",
    "#8AFAFF",
    "#80f9ff",
  ],
} satisfies Record<string, MantineColorsTuple>;
